import styles from './technology-stack.module.scss';
import animations from "@components/shared/animation/animations.module.scss";
import SharedAnimation from "@components/shared/animation";
import Image from "next/image";
import {TechnologyStackSection} from "./../../social-luke.state";

type TechnologyStackProps = {
    technologyStack: TechnologyStackSection;
}

const TechnologyStack = ({technologyStack}: TechnologyStackProps): JSX.Element => {
    return (
        <>
            <SharedAnimation render={(ref) => (
                <div ref={ref} className={`${styles.containerDifferent} ${animations.scroll__animation}`}>
                    <section className={`${styles.section}`}>
                        <h2 className={styles.technologyStack__title}>{technologyStack.title}</h2>

                        {technologyStack.sections.map((section) => (
                            <div className={styles.technologyStack__block} key={section.title}>
                                <p>{section.title}</p>
                                <div className={styles.technologyStack__blockItems}>
                                    {section.technologies.map(technology => (
                                        <div className={styles.technologyStack__blockItem}
                                             key={technology.name}>
                                            <Image src={technology.icon}
                                                   alt={technology.name}
                                                   width={technology.width}
                                                   height={technology.height}/>
                                            <p>{technology.name}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}

                    </section>
                </div>
            )}/>
        </>
    );
}

export default TechnologyStack;